module.exports = __webpack_public_path__ + "static/media/bell.d0db49c1.mp3";